import shopifyDawnGenericDefaults from '../shopify-dawn-generic/config.js';

const baseFitmentFields = window.Convermax?.config?.baseFitmentFields ?? [
  'Year',
  'Make',
  'Model',
  'Submodel',
];

const pdpWithVariants = window.document.querySelector('variant-selects');

const getItemId = ({ getItemId, getVariantId }) => {
  if (pdpWithVariants) {
    const variantId = getVariantId();
    if (variantId) {
      return `${variantId}`;
    }
  }

  return getItemId();
};

const InitFunc = () => {
  shopifyDawnGenericDefaults.InitFunc?.();

  if (pdpWithVariants) {
    window.document
      .querySelector('product-info')
      .addEventListener(
        'click',
        (e) =>
          e.target.closest('.product-form__input') &&
          setTimeout(
            () => window.Convermax.updateVerifyFitmentWidget(window.Convermax.Shopify.getVariantId()),
            1000,
          ),
      );
  }
};

export default {
  includes: ['shopify-dawn-generic'],
  ...shopifyDawnGenericDefaults,
  InitFunc,
  product: {
    ...shopifyDawnGenericDefaults.product,
    getItemId,
  },
  Widgets: [
    ...shopifyDawnGenericDefaults.Widgets.filter((w) => !['SearchHeader', 'UniversalFacet'].includes(w.name)),
    {
      name: 'SearchHeader',
      facetToggleConfig: {
        toggledFacet: { field: 'Universal', term: 'True' },
      },
    },
    {
      name: 'UniversalFacet',
      type: 'FacetToggle',
      toggledFacet: { field: 'Universal', term: 'True' },
    },
  ],
};
